export default __webpack_public_path__ + "static/media/editIconTour.beefc96f.svg";